import { render } from "./AppInputText.vue?vue&type=template&id=96887e82&scoped=true"
import script from "./AppInputText.vue?vue&type=script&lang=js"
export * from "./AppInputText.vue?vue&type=script&lang=js"

import "./AppInputText.vue?vue&type=style&index=0&id=96887e82&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96887e82"]])

export default __exports__